<template>
  <div class="banner">
    <a :href="href" target="_blank" @click="click">
      <img
        srcset="
          @/assets/img/ai-writing/banner.png    1x,
          @/assets/img/ai-writing/banner@2x.png 2x
        "
        src="@/assets/img/ai-writing/banner.png"
        alt="AIライティング"
        width="1200"
        height="100"
      />
    </a>
  </div>
</template>

<script>
import Amplitude from '@/amplitude';

export default {
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  computed: {
    href() {
      return `/f/${this.projectId}/ai-writing`;
    }
  },
  methods: {
    click() {
      Amplitude.postLogEvent('ClickLink to AI Writing - banner');
    }
  }
};
</script>

<style scoped>
.banner {
  margin-bottom: 20px;
  text-align: center;
}
.banner img {
  height: auto;
}
</style>
